import styled from 'styled-components'

export const PrototypeErrorPage = styled.div`
  /* We can't use theme tokens here, we need always dark background for
  prototypes error pages */
  background-color: #212121;
  width: 100%;
  height: 100%;
`
